// extracted by mini-css-extract-plugin
module.exports = {"body":"EmptyList_body__2p8Yr","emptyImage":"EmptyList_emptyImage__3mMPF"};